import * as React from "react";
import {css, cx} from "emotion";
import {rgba} from "polished";

import "./emulation-control.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {chain}          from "@Common/utils/fs";

import {EmulationModal}      from "../../../../../common/emulation-modal/emulation-modal";
import {showOfficeEmulation} from "../../../../../common/logic/show-office-emulation";

export const EmulationControl = ({emulationPlugins, hidden, limitByBenefit=''}) => cs(
    consumeContext("userLevels"),

    ({userLevels}, next) => (userLevels?.userLevel === 3 || userLevels?.userLevel === 4) && next(),

    consumeContext("session"),
    consumeContext("themeScheme"),

    ["emulationModal", (_, next) => EmulationModal({next, plugins: emulationPlugins, limitByBenefit})],

    ({themeScheme, emulationModal, userLevels, session}) => (
        <div
            className={cx(
                "emulation-control emulation-control-6w3", {hidden},
                css`
                    & > button {
                        color: ${themeScheme.xpresso.menuTextColor};
                        border: 1px solid ${rgba(themeScheme.xpresso.menuTextColor, .4)};

                        &:hover {
                            border-color: ${themeScheme.xpresso.menuTextColor};
                        }
                    }
                `
            )}
        >
            {(() => {
                const {full, short} = (
                    session.loading ? (
                        singleText("Loading...")
                    ) : chain(
                        [
                            showOfficeEmulation(userLevels) && session.data.branchName,
                            session.data.agentNameFirst != null && (session.data.agentNameFirst + " " + session.data.agentNameLast),
                        ].filter(v => v),
                        (_) => !_.length ? (
                            singleText(
                                showOfficeEmulation(userLevels) ? (
                                    "Select Office & User"
                                ) : (
                                    "Select User"
                                )
                            )
                        ) : (
                            flexText(
                                _,
                                {separator: " - ", limit: 43}
                            )
                        ),
                    )
                );

                return (
                    <button
                        onClick={() => emulationModal.show()}
                        title={replaceBranchOrder(full)}
                        xd-qa-type="button"
                        xd-qa-name="Selection"
                    >
                        {replaceBranchOrder(short)}

                        <i className="fa fa-pencil"/>
                    </button>
                )
            })()}
        </div>
    ),
);

const singleText = (text) => {
    return {
        full: text,
        short: text,
    }
};

const flexText = (list, {separator, limit}) => {
    return {
        full: list.join(separator),
        short: list.map((e) => {
            const eLimit = (limit - separator.length * (list.length - 1)) / list.length;
            return limitText(e, eLimit);
        }).join(separator)
    }
};

const limitText = (text, limit) => {
    if (text.length <= limit) {
        return text;
    }

    return text.substring(0, Math.floor(limit / 2)) + "..." + text.substring(text.length - Math.ceil(limit / 2));
};

const replaceBranchOrder = (branch) => {
    return branch.replace("Branch Order", "Office Order")
}
